import React from 'react';
import { Box, Image } from '@mantine/core';
import { Link } from 'react-router-dom';
import PlaceHolder from "../../assets/images/common/card-placeholder.png"

const PageTitle = ({ uuid, title, logo, name, shortHead , location }) => {
    const isAuth = localStorage.getItem('isAuth' || false);

    const displayLogo = logo || localStorage.getItem('complexImage') || PlaceHolder || '';
    const displayName = name || localStorage.getItem('complexName') || '';
    const displayLocation = location || localStorage.getItem('complexLocation') || '';

    return <Box className='w-100 mb-3'>
        {displayLogo &&
          <>
            <div style={{
              display: 'flex',
              justifyContent: 'center',

              alignItems: 'center',
              padding: '12px 16px',
              backgroundColor: '#ffffff',
              borderBottom: '1px solid #f0f0f0',
            }}>
  

  {/* Center: Icon + Name + Location */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    {/* Venue Icon */}
    <div style={{
  width: '90px',
  height: '90px',
  borderRadius: '12px',
  backgroundColor: '#FFF0E8',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  overflow: 'hidden',
}}>
  <img                        
    src={displayLogo}
    alt="venue"
    style={{
      width: '70px',
      height: '70px',
      objectFit: 'cover',
      objectPosition: 'center',
      borderRadius: '12px',
      display: 'block',
      margin: 0,
    }}
    onError={(e) => {
      e.target.src = PlaceHolder; 
    }}
  />
</div>

    {/* Name + Location */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span style={{ fontWeight: 700, fontSize: '18px', color: '#1a1a1a' }}>
          {displayName}
        </span>
        <div style={{
          width: '20px', height: '20px', borderRadius: '50%',
          backgroundColor: '#FA5000', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M2 5.5L4.5 8L9 3" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
      <span style={{ 
  fontSize: '13px', 
  color: '#666', 
  display: 'flex', 
  alignItems: 'center', 
  gap: '4px'
}}>
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" style={{ flexShrink: 0 }}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
    <circle cx="12" cy="9" r="2.5"/>
  </svg>
  <span style={{
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    maxWidth: '500px',

  }}>
    {displayLocation}
  </span>
</span>
    </div>
  </div>

  
</div>
          </>
        }
        {title && 
            <div className='text-center' style={{ display: 'flex', flexDirection: 'column', gap: '2px', alignItems: 'center' }}>
                {shortHead && uuid && (
                    <p style={{ color: '#FA5000' }} className='fw-600 m-0'>
                        {shortHead}
                    </p>
                )}

                <h6 className='fs-36 m-0 ' style={{ fontWeight: 700 }}>
                    {title}
                </h6>

                 {shortHead && uuid && (
                    <p style={{ color: '#a1a1a1', fontWeight: 600, marginTop: '8px'}} >
                    Choose your favorite sport and book your slot in just a few clicks
                </p>)}

            </div>
        }
    </Box>
}

export default PageTitle;
